module.exports = __webpack_public_path__ + "media/ad_designs/wc-ad-placement-41f2d3ad.jpg";